import { z } from "zod";

export const FormIdSchema = z.number().min(1).brand<'FormId'>();

export type FormId = z.infer<typeof FormIdSchema>;
